import React from 'react';

export const Checkout = () => {
    return (
        <div className="text">
            <p><b>Thank you for trying the Ellitech project demo. This site was developed to display my front end web development skills. Hope you enjoyed!
            </b></p>
            <p>- Ian Ellis</p>


        </div>
    )
}